module.exports = __webpack_public_path__ + "static/media/cert_53.8e081d70.jpg";